<template>
  <div>
    <div class="card card__vertical" data-aos="fade-in">
      <div class="card__img">
        <img :src="data.image" alt="company image" />
      </div>

      <div v-if="data.logo" class="card__companylogo">
        <img :src="data.logo" :alt="data.title" />
      </div>

      <h3 class="card__title">{{ data.title }}</h3>

      <div class="card__desc">
        <p class="card__address" v-if="data.addresses.length > 0">
          <LocationIcon /> {{ data.addresses[0].address }}
        </p>
        <span class="card__tel" v-if="data.addresses.length > 0">
          <Callicon /> {{ data.addresses[0].phones }}
        </span>
      </div>

      <div v-if="$root.globalData" class="card__btn">
        <router-link
          :to="`/unit/${data.id}/${slugGenerator(data.title)}`"
          class="card_link"
          >{{ $root.globalData.keys.industry_unit_button }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import CardImg from "../../assets/images/factory2.jpg";
import Callicon from "../svgs/Callicon.vue";
import LocationIcon from "../svgs/LocationIcon.vue";
import Callicon1 from "../svgs/Callicon.vue";

export default {
  components: {
    Callicon,
    LocationIcon,
    Callicon1,
  },
  methods: {
    slugGenerator(name) {
      if (name == null) return name;
      let result = " ";
      result = name.replace(/ /g, "-");
      return result;
    },
  },
  data() {
    return {
      cards: [
        {
          cardCount: 10,
          cardimg: CardImg,
          cardtitle: "لبنیات کاله",
          cardadress:
            " تهران، خیابان جمهوری، خیابان ۱۲ فروردین نبش تقاطع خیابان آذربایجان، پلاک ۱۳۶ ",
          cardtel: "۰۲۱-۶۶۴۵۴۵۱۱ , ۰۲۱-۶۱۱۲۳۶۴",
          cardlink: "مشاهده شرکت",
        },
      ],
    };
  },
  props: {
    data: Object,
  },
};
</script>

<style scoped>
.card {
  min-width: 300px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  text-align: right;
  position: relative;
  margin-bottom: 10px;
  transform: scale(0.9);
}
@media (max-width:620px){
  .card {
  min-width:50%;
  }
}
.card__companylogo {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: #fff;
  position: absolute;
  left: 10px;
  top: 150px;
  box-shadow: 0 10px 10px #ddd;

  display: flex;
  justify-content: center;
  align-items: center;
}

.card__img img {
  width: 100%;
  height: 200px;

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.card__companylogo img {
  width: 80%;
  border-radius: 100%;
}
.card__title {
  padding: 10px 1rem;
}
.card__desc {
}
.card__address,
.card__tel {
  font-size: 14px;
  color: #666;
  padding: 10px;
  display: flex;
    height: max-content;
}
.card__address {
height: 100px !important;
}
.card__tel {
  font-size: 13px;
}

.card__btn {
  width: 100%;
  text-align: center;
  margin: 1rem 0;
}

.card_link {
  padding: 7px;
  width: 70%;
  border-radius: 5px;
  border: 2px solid #0d6efd;
  background-color: #0d6efd;
  color: #fff;
  cursor: pointer;
  transition: ease all 0.3s;
}

.card_link:hover {
  box-shadow: 0 0 10px #0d6efd;
}
</style>
